import type { MeetingStatus, Platform, TipType } from '@copilot/shared';

export { KB_CATEGORY_LABELS, OUTCOME_LABELS, SENTIMENT_LABELS } from '@copilot/shared';

export const PLATFORM_LABELS: Record<Platform, string> = {
  meet: 'Google Meet',
  teams: 'Teams',
  zoom: 'Zoom',
  other: 'Other',
};

export const STATUS_LABELS: Record<MeetingStatus, string> = {
  live: 'Live',
  ended: 'Ended',
  reviewed: 'Reviewed',
};

export const TIP_TYPE_LABELS: Record<TipType, string> = {
  term: 'Term',
  say: 'Say',
  note: 'Note',
  answer: 'Answer',
};

/** Default-language options for Settings ("auto" = detect per call). */
export const LANGUAGE_OPTIONS: Array<{ value: string; label: string }> = [
  { value: 'en', label: 'English' },
  { value: 'auto', label: 'Auto-detect' },
  { value: 'de', label: 'German' },
  { value: 'fr', label: 'French' },
  { value: 'es', label: 'Spanish' },
  { value: 'it', label: 'Italian' },
  { value: 'nl', label: 'Dutch' },
  { value: 'pt', label: 'Portuguese' },
  { value: 'ar', label: 'Arabic' },
  { value: 'ur', label: 'Urdu' },
];
